/* eslint-disable max-len, quote-props, quotes */
export default {
  pl: {
    "app.errors.fatalError": "Wystąpił błąd! Spróbuj ponownie.",
    "app.errors.networkError":
      "Nie można połączyć się z serwerem. Sprawdź swoje połączenie sieciowe.",
    "app.auth.errors.wrongLoginOrPassword": "Email lub hasło niepoprawne",
    "app.validation.required": "Pole jest wymagane",
    "app.validation.email": "Email jest nieprawidłowy"
  }
};



// WEBPACK FOOTER //
// ./src/messages/translations.js